// Best Score Storage (generic utility for games)
export class BestScoreStorage {
  private readonly storageKey: string;

  constructor(gameKey: string) {
    this.storageKey = `${gameKey}-best-score`;
  }

  set(score: number): boolean {
    try {
      localStorage.setItem(this.storageKey, score.toString());
      return true;
    } catch (error) {
      console.warn('Failed to save best score:', error);
      return false;
    }
  }

  get(): number {
    try {
      const saved = localStorage.getItem(this.storageKey);
      return saved ? parseInt(saved, 10) : 0;
    } catch (error) {
      console.warn('Failed to load best score:', error);
      return 0;
    }
  }

  clear(): boolean {
    try {
      localStorage.removeItem(this.storageKey);
      return true;
    } catch (error) {
      console.warn('Failed to clear best score:', error);
      return false;
    }
  }
}
